import is from './is';

export const capitalize = (sentence: string) => {
  return sentence ? sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase() : '';
};

export const removeTrailingComma = (str: string) => {
  return str.replace(/(^,)|(,$)/g, '');
};

export const getSingleString = (str: any) => (Array.isArray(str) ? str[0] ?? '' : str);

export const convertToString = (param: any) => {
  let stringValue = '';
  if (is.array(param) || is.object(param)) {
    stringValue = JSON?.stringify(param);
  } else {
    stringValue = String(param);
  }
  return stringValue;
};

export const getFirstWord = (str: string, delimiter: string = ','): string => {
  if (typeof str !== 'string' || typeof delimiter !== 'string') {
    return '';
  }
  return str.split(delimiter)[0];
};

export default getSingleString;
